"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _logger = _interopRequireDefault(require("../logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function get(_ref) {
  var key = _ref.key;

  if (!key) {
    _logger.default.warn("[firebase] storage get error, ".concat(key));

    return false;
  }

  var res;

  try {
    res = localStorage.getItem(key);
  } catch (e) {
    _logger.default.warn('[firebase] storage get error');
  }

  return res;
}

function set(_ref2) {
  var key = _ref2.key,
      metrics = _ref2.metrics,
      url = _ref2.url;

  if (!key || !metrics || !url) {
    _logger.default.warn("[firebase] storage set error, ".concat(key, ",").concat(metrics, ",").concat(url));

    return false;
  }

  try {
    localStorage.setItem(key, JSON.stringify({
      metrics: metrics,
      url: url
    }));
  } catch (e) {
    _logger.default.warn('[firebase] storage set error');
  }
}

function clear(_ref3) {
  var key = _ref3.key;

  if (!key) {
    _logger.default.warn("[firebase] storage remove error, ".concat(key));

    return false;
  }

  try {
    localStorage.removeItem(key);
  } catch (e) {
    _logger.default.warn('[firebase] storage remove error');
  }
}

var _default = {
  get: get,
  set: set,
  clear: clear
};
exports.default = _default;